import React from 'react'
import TermsPrivacyDetails from 'src/Components/Customer/TermsPrivacyDetails';
import termsConditionImage from 'src/assets/images/website-images/term-condition-banner.png';
import { termsConditionContent } from 'src/lib/TermsConditionData';

const TermsCondition = () => {
    return (
        <div>
            <TermsPrivacyDetails
                image={termsConditionImage}
                title="Terms And Conditions"
                content={termsConditionContent}
            />
        </div>
    )
}

export default TermsCondition;